import { Icon } from "@iconify/react";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Row } from "reactstrap";
import noLogo from "../../../../assets/images/featured-job/no-logo.png";
import {
  convertToSlug,
  dataUrl,
  getJobLocationById,
  getCompanyLogo,
} from "../../../../helpers/common";
import userImage6 from "../../../../assets/images/avatar.png";
const SingleCompany = ({ company }) => {
  const locations = useSelector((state) => state.jobLocations.data);

  // 🎯 FIX 1: Safely grab the company object from the capital "Companies" array matrix
  const companyDetails = company?.Companies?.[0] || company?.company || company;

  const detailPageUrl = `/company/details/${company.id}/${convertToSlug(
    company.name || companyDetails?.employerName || "",
  )}`;
  const updateCompanyUrl = `/employer/company/edit/${company.id}`;
  const openingJobListUrl = `/employer/job/manage/${company.id}/${convertToSlug(
    company.name || companyDetails?.employerName || "",
  )}`;

  // 🎯 FIX 2: Use the direct, full URL provided by your API if it exists, otherwise use fallback construct
  const finalLogoPath =
    companyDetails?.logoUrl ||
    (company.logoUrl
      ? `${dataUrl}/jobcompanies/120x120-${company.logoUrl}`
      : null);

  console.log("company*", company.totalJobCount);

  return (
    <>
      <Col lg={12} md={12}>
        <Card className="job-box card mt-4">
          <CardBody className="p-4">
            {/* <div className="featured-label">
                <span className="featured">{5} <i className="mdi mdi-star-outline"></i></span>
              </div> */}

            <Row>
              {/* Col lg=2 */}
              <Col lg={1}>
                <div className="logo-div">
                  <img
                    src={(() => {
                      // 🎯 FIX 3: Point directly to our resolved variables
                      const logoSrc = finalLogoPath || userImage6;

                      console.log("--- LOGO DEBUGGER20 ---");
                      console.log(
                        "Resolved companyDetails object:",
                        companyDetails,
                      );
                      console.log("Final src string generated:", logoSrc);
                      return logoSrc;
                    })()}
                    alt={
                      companyDetails?.employerName ||
                      companyDetails?.name ||
                      "Company Logo"
                    }
                    className="rounded-3 img-thumbnail shadow-sm comp-logo"
                    style={{
                      width: "90px",
                      height: "90px",
                      objectFit: "contain",
                      border: "3px solid #fff",
                    }}
                    onError={(e) => {
                      console.error("--- LOGO LOAD FAILED ---");
                      console.error("Failed URL Attempted:", e.target.src);

                      // Prevent infinite error loops if fallback also fails
                      e.target.onerror = null;
                      e.target.src = userImage6;

                      console.log(
                        "Image source fell back successfully to userImage6.",
                      );
                    }}
                  />
                </div>
              </Col>

              {/* Col lg=7 */}
              <Col lg={8}>
                <div className="mt-3 mt-lg-0">
                  <h5 className="fs-17 mb-1">{company.name}</h5>
                  <ul className="list-inline mb-0">
                    <li className="list-inline-item">
                      <p className="text-muted fs-14 mb-0">
                        <i className="mdi mdi-map-marker text-primary"></i>
                        {getJobLocationById(company?.jobLocationId, locations)}
                      </p>
                    </li>

                    {company?.total_employees && (
                      <li className="list-inline-item">
                        <p className="text-muted fs-14 mb-0">
                          <Icon icon="ic:baseline-people" fontSize="16" />{" "}
                          {company?.total_employees}{" "}
                          {company?.total_employees > 1 ||
                          company?.total_employees?.includes("-") ||
                          company?.total_employees?.includes("+")
                            ? "employees"
                            : "employee"}
                        </p>
                      </li>
                    )}
                  </ul>
                </div>
              </Col>

              {/* Col lg=4 */}
              <Col lg={3} className="align-self-center">
                <ul className="list-inline mt-3 mt-lg-0 mb-0 d-flex justify-content-lg-center">
                  {/* Opening Button */}
                  <li
                    className="list-inline-item position-relative"
                    style={{ marginRight: 18 }}
                  >
                    <div className="my-badge">
                      <span>{company?.totalJobCount}</span>
                    </div>
                    <Link
                      to={openingJobListUrl}
                      state={{
                        name: company.name,
                      }}
                      className="btn btn-primary"
                    >
                      Opening Jobs
                    </Link>
                  </li>

                  {/* Edit Button */}
                  <li
                    className="list-inline-item"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Edit"
                  >
                    <Link
                      to={updateCompanyUrl}
                      state={{ companyDetails: company }}
                      className="avatar-sm bg-soft-primary d-inline-block text-center rounded-circle fs-18"
                    >
                      <i className="uil uil-edit"></i>
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default SingleCompany;
